// extracted by mini-css-extract-plugin
export default {"wrapper":"zr-z","response":"Ar-z","error":"Br-z","disabled":"Cr-z","buttons":"Dr-z","feedbackQuestionSection":"Er-z","yesNoWrapper":"Fr-z"};